<script>
    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();

    export let color = "#2A7ABC";
    export let tabs = [];
    export let selectedIndex = 0;
    export let selectedTab;

    $: selectedTab = tabs ? tabs[selectedIndex] : undefined;

    function handleSelect(i) {
        selectedIndex = i;
        dispatch('selectionChanged', { selectedIndex: i, selectedTab: tabs[i] });
    }
</script>

<div class="container">
    {#each tabs as tab, i}
        <div class="tab noselect" class:selected={selectedIndex === i} on:click={() => handleSelect(i)} style="color: {color}">{tab}</div>
    {/each}
</div>

<style>
    .container {
        display: flex;
        flex-direction: row;
    }

    .tab {
        height: max-content;
        padding: 4px 10px;
        cursor: pointer;
        opacity: .5;
        letter-spacing: 1px;
        font-weight: bold;
        filter: grayscale(100%);
    }

    .tab:hover {
        opacity: 0.75;
    }

    .tab.selected {
        opacity: 1;
        filter: none;
    }

    .noselect {
        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Safari */
        -khtml-user-select: none; /* Konqueror HTML */
        -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
        user-select: none; /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */
    }
</style>